<textarea 
    [(ngModel)]="input"
    [placeholder]="placeholder" 
    [ngStyle]="{ 'width' : width + 'px', 'height' : height + 'px'}"
    (input)="onInput.emit(input)"
    class="font-body2">
</textarea>